export const buildDeleteMessage = api => {
  const details = api.getDetails()
  return `Are you sure you want to Delete ${details.name} Discount?`
}
